// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__Dg-nR","stepsWrap":"Wrapper_stepsWrap__vE7jd","steps":"Wrapper_steps__L+0lb"};